import React from "react";

import { useTranslation } from "react-i18next";

import { InputLabel, Select, MenuItem } from "@material-ui/core";

// import { getStatesByCountry } from "lib/countries";

import { useAvailableStates } from "lib/config";


export default function StateSelector({
  country,
  state,
  onStateChange,
  label,
  disabled,
  extraValues = [],
}) {
  const { t } = useTranslation();
  const availableStates = useAvailableStates(country);

  const handleStateChange = (event) => {
    onStateChange(event.target.value);
  };


  if (country == null) {
    return <div />;
  }



  const selectedState = state || "";

  return (
    <div>
      {label ? (
        <InputLabel shrink id="state-select-label">
          {label}
        </InputLabel>
      ) : undefined}
      <Select
        displayEmpty
        labelId="state-select-label"
        id="state-select"
        value={selectedState}
        onChange={handleStateChange}
        style={{ width: "100%" }}
        disabled={disabled}
      >
        <MenuItem value="" disabled>
          {t("stateSelector.placeHolder")}
        </MenuItem>
        {availableStates.concat(extraValues).map(({ id, name }) => (
          <MenuItem key={id} value={id}>
            {name}
          </MenuItem>
        ))}
      </Select>
    </div>
  );
}
